import { connect } from 'react-redux';
import {getCustomerDetail, getCallLogList, addCallLog, getAccountNotes, addAccountNotes,
  getServiceOrder, getAuthorizedUserList, getLeadById, getServiceOrderEnquiry, updateLeads, updateServiceOrderEnquiry, getRepresentativeList, updateCallLog
} from '../../../../Action';
import LeadDetail from "../Component/LeadDetail";

const mapStateToProps = (state) => {
  const {
    CustomerList,
    CallLog,
    AccountNotes,
    ServiceOrder,
    AuthorizedUser,
    Lead,
    ServiceOrderEnquiry,
    RepresentativeList
  } = state;

  return {
    CustomerList,
    CallLog,
    AccountNotes,
    ServiceOrder,
    AuthorizedUser,
    Lead,
    ServiceOrderEnquiry,
    RepresentativeList
  }
}

const actionCreators = {
  getLeadById,
  getCustomerDetail,
  getCallLogList,
  addCallLog,
  getAccountNotes,
  addAccountNotes,
  getServiceOrder,
  getAuthorizedUserList,
  getServiceOrderEnquiry,
  updateLeads,
  updateServiceOrderEnquiry,
  getRepresentativeList,
  updateCallLog
}
export default (connect(mapStateToProps, actionCreators)(LeadDetail));
